import { HomeInfo, HomeGroupLayout } from 'components';
import React from 'react';



/**
 * 班級簡介頁面
 */

export const HomeInfoPage = () => {
  return (
    <HomeGroupLayout>
      <HomeInfo />
    </HomeGroupLayout>
  );
};



